export const HSVtoRGB = (h, s, v) => {
    var r, g, b, i, f, p, q, t;
    
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: r = v; g = t; b = p; break;
        case 1: r = q; g = v; b = p; break;
        case 2: r = p; g = v; b = t; break;
        case 3: r = p; g = q; b = v; break;
        case 4: r = t; g = p; b = v; break;
        case 5: r = v; g = p; b = q; break;
        default: break;
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}


export const RGBtoHSV = (r, g, b) => {
    var max = Math.max(r, g, b), min = Math.min(r, g, b),
        d = max - min,
        h,
        s = (max === 0 ? 0 : d / max),
        v = max / 255;

    switch (max) {
        case min: h = 0; break;
        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
        case g: h = (b - r) + d * 2; h /= 6 * d; break;
        case b: h = (r - g) + d * 4; h /= 6 * d; break;
        default: break;
    }

    return {
        h: h,
        s: s,
        v: v
    };
}

export const RGBtoHEX = (r, g, b) => {
    let hr = String('0'+parseInt(r).toString(16)).substr(-2).toUpperCase();
    let hg = String('0'+parseInt(g).toString(16)).substr(-2).toUpperCase();
    let hb = String('0'+parseInt(b).toString(16)).substr(-2).toUpperCase();

    return `${hr}${hg}${hb}`;
}

export const HEXtoColor = (hex) => {
    let r = parseInt(hex.substr(0,2), 16);
    let g = parseInt(hex.substr(2,2), 16);
    let b = parseInt(hex.substr(4,2), 16);

    return {
        r,
        g,
        b,
        ...RGBtoHSV(r, g, b)
    };
}

export const HEXtoBlackOrWhite = (hex) => {
    let colorObj = HEXtoColor(hex.substring(1,7));
    let colorVec = [colorObj.r, colorObj.g, colorObj.b];
    colorVec = colorVec.map((color) => {
        let c = color / 255.0;
        c = (c <= 0.04045 ? (c/12.92) : (((c+0.055)/1.055) ** 2.2));
        return c;
    });
    let l = 0.2126 * colorVec[0] + 0.7152 * colorVec[1] + 0.0722 * colorVec[2];
    return l > 0.3 ? '#000000' : '#ffffff';
}